/**
 * /dashboard/expenses/approvals — Manager / HR inbox (Phase 3d).
 *
 * Today the backend exposes expense approvals via the same role-filtered
 * list endpoint that powers the My expenses view; the approver-centric
 * UI is queued. For now this surface reuses ExpensesTab — the server-side
 * scope already returns the right rows for an approver.
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/expenses/approvals/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { ExpensesModuleShell } from "@/components/shared/expenses-module-shell";
import { ExpenseFeatureGate } from "@/components/expenses/expense-feature-gate";
import { ExpensesTab } from "@/components/expenses/expenses-tab";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/expenses/approvals",
)({
  component: ExpenseApprovalsRoute,
});

function ExpenseApprovalsRoute() {
  return (
    <ExpensesModuleShell
      title="Expense approvals"
      description="Review and act on expense claims from your reports."
    >
      <ExpenseFeatureGate>
        <ExpensesTab />
      </ExpenseFeatureGate>
    </ExpensesModuleShell>
  );
}
